import { searchEventsSegments } from 'modules/search/routing/search.route-segments';
import { searchEventsRouteReference } from 'modules/search/routing/search.routes';
import { SearchEventFiltersByName } from 'modules/search/types/FiltersByName/SearchEventFiltersByName';
import { SortType } from 'store/mainSearch/MainStoreMainSearchState';

import { searchGetQueryParamsFromFiltersByName } from './searchGetQueryParamsFromFiltersByName';

type Args = {
  lang: UserLocale;
  q?: string;
  radius?: 'state' | 'country' | 'auto' | string | null;
  filtersByName?: Omit<SearchEventFiltersByName, 'type'>;
  sort?: SortType;
  pageIndex?: number;
};

export function searchGetEventsRoutePath({
  lang,
  filtersByName,
  q,
  radius,
  sort,
  pageIndex,
}: Args) {
  const segment = searchEventsSegments[lang];

  const queryParams = searchGetQueryParamsFromFiltersByName(filtersByName);
  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;
  if (sort && sort !== 'relevance') queryParams.sort = sort;
  if (pageIndex) queryParams.page = pageIndex + 1;

  return searchEventsRouteReference.with({ lang, segment, ...queryParams });
}
